import { msg } from "@lingui/core/macro";

export const truncateSetDurationToFixedExpiryTimeRuleMessages = {
	name: msg({ message: "Truncate Set Duration To Fixed Expiry Time" }),
	description: msg({
		message: "Truncates a fixed duration so permit expiry stays before the configured expiry time",
	}),
	errors: {
		invalidTimeBefore: msg({ message: "Configured expiry time is invalid: {timeBefore}" }),
	},
} as const;
